(function () {
  if (window.__countrySelectorSearchInit) return;
  window.__countrySelectorSearchInit = true;

  document.addEventListener('input', function (event) {
    var input = event.target;
    if (!input || !input.classList || !input.classList.contains('country-search__input')) return;

    var wrapper = input.closest('.disclosure__list-wrapper');
    if (!wrapper) return;

    var list = wrapper.querySelector('.disclosure__list');
    if (!list) return;

    var query = input.value.trim().toLowerCase();
    var items = list.querySelectorAll('.disclosure__item');
    var divider = list.querySelector('.localization-form__divider');
    var emptyMsg = list.querySelector('.country-search__empty');
    var matches = 0;

    items.forEach(function (item) {
      if (item.classList.contains('localization-form__divider') || item.classList.contains('country-search__empty')) return;
      var haystack = item.getAttribute('data-search') || item.textContent.toLowerCase();
      var show = query === '' || haystack.indexOf(query) !== -1;
      item.hidden = !show;
      if (show) matches++;
    });

    if (divider) divider.hidden = query !== '';
    if (emptyMsg) emptyMsg.hidden = !(query !== '' && matches === 0);
  });
})();
